import React, {memo} from "react";
import {Body, Container, Foot, Head, Root, Wrap, Overlay, RandomContainer} from "./Builder-styles";
import {
    useBuilderModels,
    useBuilderSizes,
    useBuilderBlocks,
    useSubmit,
    useMobileTabs,
} from "../../hooks";
import ModelsSelector from "../ModelsSelector/ModelsSelector";
import SizesSelector from "../SizesSelector/SizesSelector";
import BuilderGroup from "../BuilderGroup/BuilderGroup";
import {getSizeDimensionsLabel} from "./Builder-utils";
import Complectations from "../Complectations/Complectations";
import Accessories from "../Accessories/Accessories";
import BuilderSummary from "../BuilderSummary/BuilderSummary";
import ResultPreview from "../ResultPreview/ResultPreview";
import MobileSectionsSelector from "../MobileSectionsSelector/MobileSectionsSelector";
import {useRecoilValue} from "recoil";
import {stateLoadingAll, stateLoadingModels, stateLoadingSizes, stateLoadingSubmit} from "../../data/atoms";
import {MobileGroupName} from "../../data";
import ButtonRandomize from "../ButtonRandomize/ButtonRandomize";
import {useBuilderUpdateExternal} from "../../hooks/useBuilderUpdateExternal";

const Builder = memo(() => {
    const isLoadingAll = useRecoilValue(stateLoadingAll);
    const isLoadingModels = useRecoilValue(stateLoadingModels);
    const isLoadingSizes = useRecoilValue(stateLoadingSizes);
    const isLoadingSubmit = useRecoilValue(stateLoadingSubmit);

    const {models, modelActive, changeActiveModel} = useBuilderModels();
    const {sizes, sizeActive, changeActiveSize} = useBuilderSizes(modelActive);

    const {
        onComplectationSelect,
        onAccessoireTypeSelect,
        onAccessoireSelect,
        onRandomGenerate,
    } = useBuilderBlocks(modelActive, sizeActive);

    const {
        tabs,
        toggleTab,
        activeTabId,
        isDrawerActive,
        swipeOverlay,
        swipeHandlers,
        wrapReference,
        headReference,
    } = useMobileTabs(isLoadingAll);

    const {screenshotRef, onSubmit} = useSubmit();

    const {onUpdateExternal} = useBuilderUpdateExternal();

    window.constructoreUsePreset = onUpdateExternal;

    return (
        <Root ref={wrapReference} $isActive={isDrawerActive} $isLoading={isLoadingSubmit}>
            <Wrap>
                <Container>
                    <Head ref={headReference} $isActive={isDrawerActive}>
                        <BuilderGroup title="Модель сумки"/>

                        <ModelsSelector
                            isLoading={isLoadingModels}
                            isDisabled={isLoadingAll}
                            models={models}
                            modelActive={modelActive}
                            onChange={changeActiveModel}/>

                    </Head>

                    <Body>
                        <ResultPreview
                            headReference={headReference}
                            isLoading={isLoadingAll}
                            isActive={isDrawerActive}
                            screenshotRef={screenshotRef}
                            onRandomClick={onRandomGenerate}
                            parameters={sizeActive?.parameters.preview || null}/>
                    </Body>

                    <Foot>
                        <RandomContainer>
                            <ButtonRandomize title="Сгенерировать случайную сумку" onClick={onRandomGenerate}/>
                        </RandomContainer>

                        <MobileSectionsSelector
                            tabs={tabs}
                            isDrawerActive={isDrawerActive}
                            tabActive={activeTabId}
                            onTabToggle={toggleTab}
                            onSwipeHandlers={swipeHandlers}>

                            <BuilderGroup
                                title="Размер сумки"
                                description={isLoadingSizes ? 'loading' : getSizeDimensionsLabel(sizeActive)}
                                isVisibleOnMobile={activeTabId === MobileGroupName.sizes}
                                isLoading={isLoadingSizes}
                            />

                            <SizesSelector
                                isLoading={isLoadingSizes}
                                isVisibleOnMobile={activeTabId === MobileGroupName.sizes}
                                sizes={sizes}
                                sizeActive={sizeActive}
                                onChange={changeActiveSize}
                                isDisabled={isLoadingAll}/>

                            <BuilderGroup
                                title="Комплектация сумки"
                                description="* Обязательные элементы сумки-конструктора"
                                isLoading={isLoadingAll}/>

                            <Complectations
                                isLoading={isLoadingAll}
                                onOptionSelect={onComplectationSelect}/>

                            <Accessories
                                onTypeSelect={onAccessoireTypeSelect}
                                onSelect={onAccessoireSelect}/>

                        </MobileSectionsSelector>

                        <BuilderSummary onSubmit={onSubmit}/>
                    </Foot>

                </Container>
            </Wrap>

            <Overlay {...swipeOverlay} $isActive={isDrawerActive}/>
        </Root>
    );
});

export default Builder;
